var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBibliothekIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36146",
    "data-name": "Gruppe 36146",
    transform: "translate(-702.83 -3690.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(702.83 3690.77)",
    fill: "#e5f5f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book",
    "data-name": "Icon awesome-book",
    d: "M17.551,14.1V.94a.938.938,0,0,0-.94-.94H3.761A3.762,3.762,0,0,0,0,3.761V16.3a3.762,3.762,0,0,0,3.761,3.761h12.85a.938.938,0,0,0,.94-.94v-.627a.948.948,0,0,0-.349-.733,8.737,8.737,0,0,1,0-2.927A.934.934,0,0,0,17.551,14.1ZM5.015,5.25a.236.236,0,0,1,.235-.235h8.305a.236.236,0,0,1,.235.235v.784a.236.236,0,0,1-.235.235H5.25a.236.236,0,0,1-.235-.235Zm0,2.507a.236.236,0,0,1,.235-.235h8.305a.236.236,0,0,1,.235.235v.784a.236.236,0,0,1-.235.235H5.25a.236.236,0,0,1-.235-.235Zm9.927,9.794H3.761a1.254,1.254,0,0,1,0-2.507H14.942A14.1,14.1,0,0,0,14.942,17.551Z",
    transform: "translate(716.055 3702.74)",
    fill: "#1c9d87"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBibliothekIcon);
export default __webpack_public_path__ + "static/media/BibliothekIcon.901dbdc356b12814b0cdb780fd623d4a.svg";
export { ForwardRef as ReactComponent };